import React, { useMemo } from "react";

import useStrategyDashboardChartMarketFromUrl from "../../../../../hooks/useStrategyDashboardChartMarketFromUrl";
import {
  getStrategyDashboardChartMarkets,
  mergeStrategyDashboardTableDefaultSettings
} from "../../../../../lib/StrategyDashboard/strategyDashboardChartMarkets";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import UniversalTableLiteWeb from "../../../common/UniversalTableLiteWeb";
import StrategyViewFullTableLink from "./StrategyViewFullTableLink";

const StrategyIndicatorsTable = ({ preview = false }) => {
  const dashboard = useStrategyDashboardConfig();
  const table = dashboard.indicatorsTable;
  const chartMarkets = useMemo(
    () => getStrategyDashboardChartMarkets(dashboard),
    [dashboard]
  );
  const { tableMarketFilters } =
    useStrategyDashboardChartMarketFromUrl(chartMarkets);

  const defaultSettings = useMemo(
    () =>
      preview
        ? {
            pagination: {
              current: 1,
              rowsPerPage: 8
            }
          }
        : {},
    [preview]
  );

  const initialSettings = useMemo(() => {
    const merged = mergeStrategyDashboardTableDefaultSettings(
      {},
      tableMarketFilters
    );

    return Object.keys(merged).length > 0 ? merged : null;
  }, [tableMarketFilters]);

  if (!table) {
    return null;
  }

  return (
    <UniversalTableLiteWeb
      resourceId={table.resourceId}
      fitColumns={Boolean(table.fitColumns)}
      options={preview ? { skipAccessCheck: true } : undefined}
      belowTable={preview ? <StrategyViewFullTableLink /> : undefined}
      usePagination={true}
      hideLoadMore={preview}
      defaultSettings={defaultSettings}
      initialSettings={initialSettings}
      fetchConfigParams={
        table.fetchConfigUrlPath
          ? { urlPath: table.fetchConfigUrlPath }
          : undefined
      }
      fetchDataParams={
        table.fetchDataUrlPath ? { urlPath: table.fetchDataUrlPath } : undefined
      }
      useUrlSettings={!preview}
    />
  );
};

export default StrategyIndicatorsTable;
